var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading",class:_vm.value && 'flex'},[_c('span',{staticClass:"dot-falling"}),_c('div',{staticClass:"content",style:(_vm.value ? 'opacity: 0' : 'opacity: 1')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }